import config from "../../config";
const baseUrl = config.baseUrl;

export const TermsAndConditionsUrls = {

  
  TERMSANDCONDITIONS_ADD: baseUrl + "/terms_and_conditions",
  TERMSANDCONDITIONS_LIST: baseUrl + "/terms_and_conditions",

}